export function fitTextArea() {
  let textArea = document.getElementById("orion-chat-text-area")
  textArea.style.height = ""; /* Reset the height*/
  textArea.style.height = Math.min(textArea.scrollHeight, 300) + "px";
}


// WEBPACK FOOTER //
// ./src/views/ChatPage/chatPageUtil/fitTextArea.js